<template>
    <div class="auth-page">
        <q-card class="auth-card" flat>
            <div style="width: 100%; display: flex; justify-content: center;">
                <img class="brand-logo" src="../assets/SERA_LOGO.png" alt="SERA" />
            </div>
            <div v-if="!requestSent">
                <h1>Password request</h1>
                <p class="auth-copy">Enter your User ID and registered email address. The administrator will review your
                    request.</p>

                <q-form @submit.prevent="sendRequest">
                    <div class="form-field">
                        <label class="field-label">User ID</label>
                        <q-input v-model.trim="form.userId" outlined dense
                            :rules="[(val) => !!val || 'User ID is required']" lazy-rules />
                    </div>

                    <div class="form-field">
                        <label class="field-label">Registered email address</label>
                        <q-input v-model.trim="form.email" outlined dense type="email"
                            :rules="[(val) => !!val || 'Email is required', (val) => emailPattern.test(val) || 'Enter a valid email address']"
                            lazy-rules />
                    </div>

                    <div class="form-field">
                        <label class="field-label">Note, optional</label>
                        <q-input v-model.trim="form.note" outlined type="textarea" rows="3"
                            placeholder="Add any helpful details for the administrator." />
                    </div>

                    <q-btn no-caps unelevated type="submit" label="Send request" class="submit-btn"
                        :loading="isSubmitting" />
                </q-form>

                <router-link to="/login" class="back-link">Back to sign in</router-link>
            </div>

            <div v-else class="success-state">
                <div class="success-icon">
                    <q-icon name="check_circle" size="42px" />
                </div>
                <h1>Request sent</h1>
                <p class="auth-copy">Your password request has been submitted. An administrator will review it and get
                    back to you.</p>

                <router-link to="/login" class="back-link">Back to sign in</router-link>
            </div>
        </q-card>
    </div>
</template>

<script>
    import axios from 'axios';
    import apis from '@/utilities';

    export default {
        name: 'PasswordRequest',

        data() {
            return {
                form: {
                    userId: '',
                    email: '',
                    note: '',
                },
                isSubmitting: false,
                requestSent: false,
                emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            };
        },

        computed: {
            url() {
                return this.$store.getters.url;
            },
            userId() {
                return this.$store.state.userId
            }
        },

        methods: {
            async sendRequest() {
                if (!this.form.userId || !this.form.email) return;
                if (!this.emailPattern.test(this.form.email)) {
                    this.$q.notify({ type: 'negative', message: 'Please enter a valid email address.', position: 'top' });
                    return;
                }

                this.isSubmitting = true;

                const payload = {
                    UserId: this.userId,
                    RequestUserId: this.form.userId,
                    RequestEmail: this.form.email,
                    RequestNote: this.form.note,
                }



                try {
                    const response = await axios.post(`${this.url}/${apis.RequestPasswordReset}`, payload);
                    if (response.data.success && response.data.validationState == 0) {
                        this.requestSent = true;
                    }
                    this.globalNotification(response.data.message, response.data.validationState)
                } catch (err) {
                    console.error(err);
                    this.$q.notify({ type: 'negative', message: 'Unable to send request. Please try again.', position: 'top' });
                } finally {
                    this.isSubmitting = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
@import '../styles/quasar.scss';

.auth-page {
    min-height: 100vh;
    padding: 24px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f4f9fb 0%, #eef4f7 45%, #e9f1f5 100%);
}

.auth-card {
    width: 100%;
    max-width: 440px;
    padding: 32px 30px;
    background: #fff;
    border: 1px solid #e3ebed;
    border-radius: 14px;
    box-shadow: 0 20px 45px rgba(13, 76, 92, 0.08);
}

.brand-logo {
    height: 24px;
    margin-bottom: 26px;
}

h1 {
    margin: 0 0 8px;
    color: #1c2a2e;
    font-size: 24px;
    font-weight: 600;
}

.auth-copy {
    margin: 0 0 24px;
    color: #73858a;
    font-size: 13px;
    line-height: 1.5;
}

.form-field {
    margin-bottom: 18px;
}

.field-label {
    display: block;
    margin-bottom: 6px;
    color: #35525a;
    font-size: 13px;
    font-weight: 700;
}

.form-field :deep(.q-field__control) {
    background: #fff;
}

.submit-btn {
    width: 100%;
    min-height: 44px;
    margin-top: 6px;
    color: #fff;
    background: $primary-gradient;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 700;
}

.back-link {
    display: inline-block;
    margin-top: 18px;
    color: $primary;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
}

.back-link:hover {
    text-decoration: underline;
}

/* ================= SUCCESS STATE ================= */

.success-state {
    text-align: left;
}

.success-icon {
    width: 56px;
    height: 56px;
    margin-bottom: 16px;
    display: grid;
    place-items: center;
    color: #2f8a4a;
    background: #e6f5ea;
    border-radius: 50%;
}

/* ============================================================
   MOBILE
   ============================================================ */

@media (max-width: 480px) {
    .auth-card {
        padding: 26px 20px;
    }
}
</style>